import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderAlert } from '../Alert/Alert';
import store from '../../redux/store';
import { isSheetUpdatedByOtherUser, removeLockFromSheet } from '../../redux/action/sheetAction';
import { debounce, clearLocalStorageExceptNetworkKeys } from '../../helpers/helper';
import ACTION_TYPES from '../../redux/types';

const InactivityAlert = ({ onUserActivity }) => {
  const [inactive, setInactive] = useState(false);
  const { currentSelectedSheet } = useSelector((state) => state.sheetReducer);

  const dispatch = useDispatch();

  const inactivityTimer = useRef(null); 
  const isRemoveLockCalled = useRef(false); 

  const resetTimer = () => {
    
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }

    
    inactivityTimer.current = setTimeout(async () => {
      if (!isRemoveLockCalled.current) {
        setInactive(true);
        const currentSheet = store.getState().sheetReducer.currentSelectedSheet;

       
        if (currentSheet?.id) {
          await removeLockFromSheet(currentSheet.id);
          isRemoveLockCalled.current = true; 
        }

        localStorage.setItem('inactive', 'true');
        console.log('Session inactive');
      }
    }, 600000); 
  };

  const handleActivity = async () => {
    if (isRemoveLockCalled.current==true && localStorage.getItem('inactive') === 'true' || localStorage.getItem('inactive') === true) {
      setInactive(false);
      isRemoveLockCalled.current = false; 

      const currentSheet = store.getState().sheetReducer.currentSelectedSheet;      
      if (currentSheet?.id && window.location.pathname.indexOf('sheet') !== -1) {
        localStorage.setItem('inactive', 'false');

        let isSheetUpdated = await isSheetUpdatedByOtherUser(currentSheet.id);
        if (isSheetUpdated) {
          dispatch({type : ACTION_TYPES.SET_RESETISSHEETUPDATEDREFAFTERINACTIVITY , resetIsSheetUpdatedRefAfterInactivity : true});
          renderAlert('Refreshing the sheet to apply the latest changes', 'info');

          const oldSelectedSheet = currentSheet;
          dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: '' });

          setTimeout(() => {
            const { userData } = store.getState().userReducer;
            const { isSharedWorkbook } = store.getState().workbookReducer;
            oldSelectedSheet.locked = isSheetUpdated.locked;
            delete oldSelectedSheet.Rows;
            if ((oldSelectedSheet.user_email !== userData.email) && !isSharedWorkbook) {
              dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: oldSelectedSheet, selectedSheetId: '' });
            } else {
              dispatch({ type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: oldSelectedSheet, selectedSheetId: currentSheet.id });
            }
          }, 1500);
        } else {
          localStorage.setItem('inactive', 'false');
          setInactive(false);
        }
      } else {
        localStorage.setItem('inactive', 'false');
      }
    }

    resetTimer(); 
  };

  useEffect(() => {
    
    window.addEventListener('mousemove', debounce(handleActivity, 1000));
    window.addEventListener('keydown', debounce(handleActivity, 1000));

    
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
    };
  }, []);

  useEffect(() => {

    const handleBeforeUnload = (event) => {
        clearLocalStorageExceptNetworkKeys();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [currentSelectedSheet]);

  return (
    <div>
      {inactive && (
        <div>
        </div>
      )}
    </div>
  );
};

export default InactivityAlert;
